<div
  class="layout-sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="layout-sidebar-top">
    <a href="/">
      <p-image
        src="assets/logo/icon.png"
        width="100"
        alt="pflegix-logo"
        class="layout-sidebar-logo-slim"
      />
    </a>
    <button
      class="layout-sidebar-anchor p-link"
      type="button"
      (click)="anchor()"
    ></button>
  </div>
  @if (menuProfilePosition === 'start') {
    <app-menu-profile #menuProfileStart></app-menu-profile>
  }
  <div
    #menuContainer
    class="layout-menu-container"
  >
    <app-menu></app-menu>
  </div>
  @if (menuProfilePosition === 'end') {
    <app-menu-profile #menuProfileEnd></app-menu-profile>
  }
</div>
